import { Button, Flex, Select, Text } from '@radix-ui/themes';
import { useState } from 'react';

const SUBJECTS = [
  'Mathematics',
  'English',
  'Science',
  'Social Studies',
  'Physics',
  'Chemistry',
  'Biology',
];

const LEVELS = Array.from({ length: 12 }, (_, i) => `Class ${i + 1}`);

const DAYS = [
  { id: 'mon', label: 'Mon' },
  { id: 'tue', label: 'Tue' },
  { id: 'wed', label: 'Wed' },
  { id: 'thu', label: 'Thu' },
  { id: 'fri', label: 'Fri' },
  { id: 'sat', label: 'Sat' },
];

const AddClassForm = ({ onSubmit, onCancel }) => {
    const [formData, setFormData] = useState({
        subject: '',
        level: '',
        days: [],
    });

    const handleDayToggle = (dayId) => {
        setFormData(prev => ({
            ...prev,
            days: prev.days.includes(dayId)
                ? prev.days.filter(d => d !== dayId)
                : [...prev.days, dayId]
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit}>
            <Flex direction="column" gap="3">
                <Select.Root
                    value={formData.subject}
                    onValueChange={(value) => setFormData({ ...formData, subject: value })}
                >
                    <Select.Trigger placeholder="Select subject" />
                    <Select.Content>
                        <Select.Group>
                            {SUBJECTS.map(subject => (
                                <Select.Item key={subject} value={subject}>
                                    {subject}
                                </Select.Item>
                            ))}
                        </Select.Group>
                    </Select.Content>
                </Select.Root>

                <Select.Root
                    value={formData.level}
                    onValueChange={(value) => setFormData({ ...formData, level: value })}
                >
                    <Select.Trigger placeholder="Select class level" />
                    <Select.Content>
                        <Select.Group>
                            {LEVELS.map(level => (
                                <Select.Item key={level} value={level}>
                                    {level}
                                </Select.Item>
                            ))}
                        </Select.Group>
                    </Select.Content>
                </Select.Root>

                <Text size="2" mb="2">Select Days</Text>
                <Flex gap="2" wrap="wrap">
                    {DAYS.map(day => (
                        <Button
                            key={day.id}
                            variant={formData.days.includes(day.id) ? 'solid' : 'soft'}
                            onClick={() => handleDayToggle(day.id)}
                            type="button"
                        >
                            {day.label}
                        </Button>
                    ))}
                </Flex>

                <Flex gap="3" justify="end" mt="4">
                    <Button variant="soft" color="gray" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type="submit">
                        Add Class
                    </Button>
                </Flex>
            </Flex>
        </form>
    );
};

export default AddClassForm;

